import React, { Component } from "react";
import { connect } from "react-redux";
import TopBar from "./TopBar";

import _ from "i18n";
import CampaignListFilter from "campaign/list/CampaignListFilter";
import CampaignList from "campaign/list/CampaignList";
import {
  initCampaignListFilter,
  initCampaignListItems,
  setEmailPaginationPage,
} from "../../actions/actions/campaign";
import TTPPaginator from "common/list/TTPPaginator";
import NotFound from "notFound/NotFound";
import NewsletterUASend from "./NewsletterUASend";
import PreviewSidebar from "./PreviewSidebar";
import {
  fetchCampaign,
  fetchCampaigns,
  fetchLastSentCampaign,
  persistCampaign,
} from "../../actions/thunks/campaign";
import {
  initCurrentEmailCampaignData,
  setCurrentCampaignTheme,
  setCurrentEmailCampaignData,
  setIsNlBlog,
  setNumCampaign,
  setUaNewsletterNumber,
  setNewsletterFrequency,
  setNewsletterChanged,
  setSendType,
  setSendMode,
  setNewletterLanguage,
} from "../../actions/actions/currentCampaign";
import {
  addFeedToNewsletter,
  initNewsletterBlocks,
  initNewsletterFeeds,
  setCurrentDndTheme,
  setCurrentNewsletterTemplate,
} from "../../actions/actions/theme";
import { fetchTemplate } from "../../actions/thunks/theme";
import { fetchSesEmailsStatuses } from "../../actions/thunks/params";
import {
  formatArticle,
  enrichAuthorsWithNewsletterImage,
} from "../../services/article";
import { formatFormation } from "../../services/event";
import { formatWakeUp } from "../../services/wakeup";
import { formatTaxtvshow } from "../../services/taxtvshow";
import { toast } from "react-toastify";
import { hasValidLength, isValidEmail } from "../../services/validation";
import { onError, onSuccess } from "../../services/utils";
import {
  fetchNewsletterUAArticles,
  fetchNewsletterUAArticlesByPeriod,
  fetchNewsletterChannel,
} from "../../actions/thunks/newsletterUA";
import { getFirstArticleChannelId } from "../../services/channel";
import StatisticsPage from "./StatisticsPage";
import moment from "moment/moment";
import DrawerIframe from "../common/DrawerIframe/DrawerIframe";
import { TTP_BLOG_URL } from "../../config";
import ApprovalResponseWrapper from "../approval/feedback/ApprovalResponse";
import SubMenuUA from "./SubMenuUA";
import { ucFirst } from "../../services/common";
import ApprovalSettings from "../approval/setting/ApprovalSettings";
import ChoicePage from "./ChoicePage";
import ThemesListPage from "../theme/ThemesListPage";
import GenericEmailPage from "../generic-emailings/GenericEmailPage";
import GenericEmail from "../generic-emailings/GenericEmail";
import Administration from "../settings/Administration";
import Settings from "../settings/Settings";
import RichText from "./RichText";
import MailExpressPage from "./MailExpressPage";
import List from "../eBox/list/List";
import { setInAdminSearchMode } from "../../actions/actions/eBox";
import { fetchEBox, fetchEboxCountStatus } from "../../actions/thunks/eBox";
import PageHeader from "../common/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchClientSettings } from "../../actions/thunks/auth";
import DefaultSettings from "../settings/DefaultSettings";
import ThemeCategoryList from "../settings/theme-category/ThemeCategoryList";

const mapStateToProps = (state) => ({
  campaigns: state.campaigns.list,
  filter: state.campaigns.list.filter,
  paginationPage: state.campaigns.list.emailPaginationPage,
  pageSize: state.campaigns.list.emailPageSize,
  currentTemplate: state.themes.newsletter.currentTemplate,
  blocks: state.themes.newsletter.blocks,
  currentTheme: state.themes.currentDndTheme,
  fetchingArticles: state.articles.fetching,
  currentCampaign: state.currentCampaign.email,
  updating: state.currentCampaign.email.updating,
  uaNewsletterId: state.currentCampaign.uaNewsletter.uaNewsletterId,
  isUaNewsletter: state.currentCampaign.uaNewsletter.isUaNewsletter,
  programmedDate: state.currentCampaign.uaNewsletter.programmedDate,
  id: state.currentCampaign.email.id,
  recipientType: state.currentCampaign.email.recipientType,
  manualRecipients: state.currentCampaign.email.manualRecipients,
  recipientsCount: state.campaigns.recipients.recipientsTotalCount,
  auth: state.auth,
  sesEmails: state.params.sesEmails?.items || {},
  nbOfRecipients: state.currentCampaign.email.nbOfRecipients,
  language: state.currentCampaign.email.language,
  articleNewsletterId: state.currentCampaign.email.articleNewsletterId,
  currentStep: state.currentCampaign.email.currentSideBar,
  html: state.currentCampaign.email.html,
  idApproval: state.currentCampaign.uaNewsletter.idApproval,
  design: state.currentCampaign.email.design,
  isNlBlog: state.currentCampaign.uaNewsletter.isNlBlog,
  templates: state.themes.list.items,
  totalUniqueRecipients: state.campaigns.recipients.totalUniqueRecipients,
  ebox: state.currentCampaign.uaNewsletter.ebox,
  inAdminSearchMode: state.ebox.list.inAdminSearchMode,
  isUaVersion: state.campaigns.recipients.isUaVersion,
  lastNumNewsletter: state.currentCampaign.email.lastNumNewsletter,
  numCampaign: state.currentCampaign.uaNewsletter.numCampaign,
  lastSentDate: state.currentCampaign.email.lastSentDate,
  themeCampaign: state.currentCampaign.email.theme,
  newsletterNumber: state.currentCampaign.uaNewsletter.newsletterNumber,
  newsletterFrequency: state.currentCampaign.uaNewsletter.newsletterFrequency,
  neweletterLanguage: state.currentCampaign.uaNewsletter.neweletterLanguage,
  isCampaignFetching: state.currentCampaign.email.fetching,
  sendType: state.currentCampaign.uaNewsletter.sendType,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSesEmailsStatuses: () => dispatch(fetchSesEmailsStatuses()),
  initCampaignListItems: () => dispatch(initCampaignListItems()),
  initCampaignListFilter: () => dispatch(initCampaignListFilter()),
  fetchCampaigns: () => dispatch(fetchCampaigns(true)),
  setEmailPaginationPage: (paginationPage) =>
    dispatch(setEmailPaginationPage(paginationPage)),
  setCurrentCampaignTheme: (theme) => dispatch(setCurrentCampaignTheme(theme)),
  setCurrentDndTheme: (theme) => dispatch(setCurrentDndTheme(theme)),
  fetchNewsletterUAArticles: (params) =>
    dispatch(fetchNewsletterUAArticles(params)),
  addFeedToNewsletter: (article) => dispatch(addFeedToNewsletter(article)),
  persistCampaign: (data) => dispatch(persistCampaign(data, true)),
  fetchCampaign: (id) => dispatch(fetchCampaign(id)),
  setCurrentEmailCampaignData: (scheduledDeliveryAt) =>
    dispatch(setCurrentEmailCampaignData(scheduledDeliveryAt)),
  fetchNewsletterUAArticlesByPeriod: (data) =>
    dispatch(fetchNewsletterUAArticlesByPeriod(data)),
  fetchNewsletterChannel: (channelId) =>
    dispatch(fetchNewsletterChannel(channelId)),
  initNewsletterBlocks: () => dispatch(initNewsletterBlocks()),
  initNewsletterFeeds: () => dispatch(initNewsletterFeeds()),
  setCurrentCampaign: (data) => dispatch(setCurrentEmailCampaignData(data)),
  initCurrentCampaign: (data) => dispatch(initCurrentEmailCampaignData(data)),
  updateIsNlBlog: (isNlBlog) => dispatch(setIsNlBlog(isNlBlog)),
  fetchEBox: () => dispatch(fetchEBox()),
  fetchEboxCountStatus: (flag) => dispatch(fetchEboxCountStatus(flag)),
  setInAdminSearchMode: (flag) => dispatch(setInAdminSearchMode(flag)),
  setNumCampaign: (numCampaign) => dispatch(setNumCampaign(numCampaign)),
  setUaNewsletterNumber: (newsletterNumber) =>
    dispatch(setUaNewsletterNumber(newsletterNumber)),
  setNewsletterFrequency: (newsletterFrequency) =>
    dispatch(setNewsletterFrequency(newsletterFrequency)),
  setNewsletterChanged: (newsletterChanged) =>
    dispatch(setNewsletterChanged(newsletterChanged)),
  setSendType: (sendType) => dispatch(setSendType(sendType)),
  fetchTemplate: (id) => dispatch(fetchTemplate(id)),
  setCurrentNewsletterTemplate: (data) =>
    dispatch(setCurrentNewsletterTemplate(data)),
  setSendMode: (sendMode) => dispatch(setSendMode(sendMode)),
  setNewletterLanguage: (neweletterLanguage) =>
    dispatch(setNewletterLanguage(neweletterLanguage)),
  fetchLastSentCampaign: (sendMode) =>
    dispatch(fetchLastSentCampaign(sendMode)),
  fetchClientSettings: () => dispatch(fetchClientSettings()),
});

class NewsletterUAPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: "LIST_PAGE",
      constructDesign: false,
      generateHtml: false,
      setNewsletter: false,
      showPreview: false,
      newsletterId: null,
      hasArticles: false,
      plan: "",
      periodConfig: "",
      month: null,
      year: null,
      isPeriodChanged: false,
      isPeriodProgrammed: false,
      selectionChanged: false,
      allFiltersTab: [],
      senders: [],
      sendModeState: "",
      suppressAutoPreview: false,
      newsletterNumberState: "",
      newsletterFrequencyState: "",
      audienceState: "",
      newsletterChangedState: false,
    };
    this.latestPersonalizedArticlesRequestId = 0;
  }

  computeNextNewsletter = (rawNum, lastSentDate) => {
    if (!rawNum && rawNum !== 0 && rawNum !== "0") return null;

    let numNewsletter = rawNum;
    const currentYear = moment().format("YYYY");
    const lastSentYear = lastSentDate
      ? moment(lastSentDate).format("YYYY")
      : moment().format("YYYY");

    if (/^\d+$/.test(numNewsletter)) {
      let nextNumber = (parseInt(numNewsletter) + 1)
        .toString()
        .padStart(numNewsletter.length, "0");

      if (lastSentYear !== currentYear) {
        nextNumber = "01";
      }
      return nextNumber;
    }

    if (/^\d{4}-\d+$/.test(numNewsletter)) {
      const [year, campaignNumber] = numNewsletter.split("-");
      let nextCampaignNumber =
        year === currentYear ? parseInt(campaignNumber) + 1 : 1;
      return `${currentYear}-${nextCampaignNumber.toString().padStart(campaignNumber.length, "0")}`;
    }

    if (/^#\d{4}-\d+$/.test(numNewsletter)) {
      const [year, campaignNumber] = numNewsletter.split("#")[1].split("-");
      if (year !== undefined && campaignNumber !== undefined) {
        let nextCampaignNumber =
          year === currentYear ? parseInt(campaignNumber) + 1 : 1;
        return `#${currentYear}-${nextCampaignNumber.toString().padStart(campaignNumber.length, "0")}`;
      }
    }

    return null;
  };
  buildSenders = () => {
    const verifiedEmails =
      this.props.auth?.currentSetting?.verifiedEmails || [];
    const sesEmails = this.props.sesEmails || {};
    return [...verifiedEmails].reverse().map((e) => ({
      email: e.email,
      value: e.email,
      label: e.name || e.email,
      name: e.name || "",
      status: sesEmails[e.email]?.VerificationStatus || "Failed",
    }));
  };

  componentDidMount() {
    const {
      initCampaignListItems,
      initCampaignListFilter,
      fetchCampaigns,
      isUaNewsletter,
      uaNewsletterId,
      auth,
      idApproval,
      isNlBlog,
      ebox,
      fetchEBox,
      fetchEboxCountStatus,
    } = this.props;

    initCampaignListItems();
    initCampaignListFilter();

    if (idApproval !== null && idApproval !== "null") {
      this.setState({ currentPage: "APPROVAL_RESPONSE" });
    } else {
      fetchCampaigns();
    }
    if (ebox && ebox === "true") {
      this.setState({ currentPage: "EBOX_PAGE" });
      setInAdminSearchMode(false);
      fetchEBox();
      fetchEboxCountStatus(false);
    }

    if (isUaNewsletter === "true" || isNlBlog === "true") {
      this.setState({ currentPage: "SEND_PAGE" });
    }
    if (uaNewsletterId && uaNewsletterId !== "null") {
      this.setState({ newsletterId: uaNewsletterId, currentPage: "SEND_PAGE" });
    }
    const requestedSubPage = this.props.location?.state?.subPage;
    if (requestedSubPage) {
      this.setState({ currentPage: requestedSubPage });
    }
    this.props.fetchSesEmailsStatuses();
    this.setState({ senders: this.buildSenders() });
    const nlpreferences = auth.currentClient.newsletterPreferences;
    if (nlpreferences !== null) {
      if (nlpreferences?.apps?.length > 0) {
        var filteredApps = nlpreferences.apps.filter(
          (app) => app.type === "BLOG_NL_CREATE",
        );
        this.setState({
          plan: filteredApps[0].config,
        });
      }
    }
    if (this.props.location?.state?.subPage) {
      this.setState({ currentPage: this.props.location.state.subPage });
    }
    window.addEventListener("message", this.handleMessageFromBlog);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.auth?.currentSetting?.verifiedEmails !==
        this.props.auth?.currentSetting?.verifiedEmails ||
      prevProps.sesEmails !== this.props.sesEmails
    ) {
      this.setState({ senders: this.buildSenders() });
    }
    const { filter, paginationPage, pageSize } = prevProps;
    const {
      setCurrentDndTheme,
      currentTheme,
      setCurrentCampaignTheme,
      initNewsletterBlocks,
      initNewsletterFeeds,
      templates,
      isUaVersion,
      lastNumNewsletter,
      setNumCampaign,
      currentStep,
      lastSentDate,
      themeCampaign,
      setCurrentCampaign,
      setSendType,
      fetchLastSentCampaign,
      sendType,
    } = this.props;
    const {
      periodConfig,
      month,
      year,
      selectionChanged,
      currentPage,
      newsletterId,
      newsletterNumberState,
      newsletterFrequencyState,
    } = this.state;
    if (newsletterId && newsletterId !== prevState.newsletterId) {
      this.setState({ suppressAutoPreview: true });
    }
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize ||
      (prevState.currentPage !== currentPage && currentPage === "LIST_PAGE") ||
      (prevProps.isUaVersion !== isUaVersion && isUaVersion)
    ) {
      this.props.fetchCampaigns();
    }

    if (
      (prevState.periodConfig !== periodConfig && periodConfig) ||
      prevState.month !== month ||
      prevState.year !== year ||
      prevState.newsletterNumberState !== newsletterNumberState ||
      (prevState.selectionChanged !== selectionChanged && selectionChanged)
    ) {
      if (prevState.selectionChanged !== selectionChanged && selectionChanged) {
        toast.success(_("Data saved successfully"), _("successfulAction"));
      }

      this.setState({ hasArticles: false, isPeriodChanged: true });
      //this.setState({ selectionChanged: false });
       if (sendType !== "immediate") {
        setSendType("scheduled");
      }
      initNewsletterFeeds();
      initNewsletterBlocks();

      this.setState({
        generateHtml: false,
        constructDesign: false,
        setNewsletter: false,
      });
      //this.setState({ showPreview: false });
      let data = {
        periodConfig,
        month,
        year,
        newsletterNumber: newsletterNumberState,
      };
      // A l'ouverture d'une campagne existante, ActionsCell injecte deja
      // periodConfig / month / year dans le state : la recherche par periode
      // partirait donc avant que le blog ait resolu le numero de newsletter
      // depuis l'articleNewsletterId de la campagne. Sans numero, l'API
      // retombe sur la newsletter 1 (`newsletterNumber || 1`) et renvoie
      // l'articleNewsletter d'une autre newsletter, qui ecrase celui de la
      // campagne. On attend que le blog nous renvoie le numero : il relance
      // ce meme bloc via newsletterNumberState.
      const waitingForBlogNewsletterNumber =
        newsletterId != null &&
        this.state.plan === "PERSONALIZED" &&
        !newsletterNumberState;

      if (!waitingForBlogNewsletterNumber) {
        this.fetchPersonalizedArticles(data);
      }
    }

    if (
      prevState.setNewsletter !== this.state.setNewsletter &&
      this.state.setNewsletter
    ) {
      let editor = (this.editor && this.editor.editor) || window.unlayer;
      if (!editor) {
        return;
      }
      if (typeof editor.exportHtml !== "function") {
        return;
      }
      editor.exportHtml(({ html, design }) => {
        if (templates && templates.length > 0) {
          let theme = {
            ...currentTheme,
            id: themeCampaign?.id,
            design,
            content: html,
          };
          setCurrentDndTheme(theme);
          setCurrentCampaignTheme(theme);
          this.setState({ showPreview: true });
        } else {
          let theme = { ...currentTheme, design, content: html };
          setCurrentDndTheme(theme);
          setCurrentCampaignTheme(theme);
          this.setState({ showPreview: true });
        }
      });
    }

    if (currentStep === "PERIODS") {
      window.addEventListener("message", this.handleMessage);
    }
    if (currentPage !== prevState.currentPage && currentPage === "LIST_PAGE") {
      this.setState({
        constructDesign: false,
        generateHtml: false,
        setNewsletter: false,
        showPreview: false,
        newsletterId: null,
        hasArticles: false,
        periodConfig: "",
        month: null,
        year: null,
        isPeriodChanged: false,
        isPeriodProgrammed: false,
        selectionChanged: false,
        suppressAutoPreview: false,
        newsletterNumberState: "",
        newsletterFrequencyState: "",
      });
      // Reset newsletter number and frequency when returning to the list page
      this.props.setUaNewsletterNumber(null);
      this.props.setNewsletterFrequency(null);
      this.props.setCurrentDndTheme(null);
      setCurrentCampaign({ themeId: null });
    }

    if (newsletterId == null) {
      // If the last number changed and is valid, compute next
      if (
        lastNumNewsletter !== prevProps.lastNumNewsletter &&
        lastNumNewsletter &&
        lastNumNewsletter !== "undefined" &&
        lastNumNewsletter !== 0 &&
        lastNumNewsletter !== "0"
      ) {
        const next = this.computeNextNewsletter(
          lastNumNewsletter,
          lastSentDate,
        );
        if (next) setNumCampaign(next);
      } else {
        // Ensure we have a sane default when creating a new newsletter
        const { numCampaign } = this.props;
        if (!numCampaign || numCampaign === "0") {
          setNumCampaign("1");
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  handleMessageFromBlog = (event) => {
    const { updateIsNlBlog } = this.props;
    if (event.data.from_blog && event.data.from_blog === "true") {
      this.setState({ currentPage: "SEND_PAGE" });
      updateIsNlBlog(true);
    }
  };

  handleMessage = (event) => {
    let url = TTP_BLOG_URL;
    if (url.endsWith("/")) {
      url = url.slice(0, -1);
    }
    if (event.origin !== url) {
      return;
    }
    this.setState({ isPeriodChanged: false });

    const {
      periodConfig,
      month,
      year,
      isPeriodProgrammed,
      selectionChanged,
      articleNewsletterId,
      newsletterNumber,
      newsletterChanged,
      newsletterFrequency,
      neweletterLanguage,
    } = event.data;

    const {
      setCurrentCampaign,
      setUaNewsletterNumber,
      setNewsletterFrequency,
      setNewsletterChanged,
      setNewletterLanguage,
      setSendType,
    } = this.props;

    if (
      periodConfig &&
      ((this.state.periodConfig !== periodConfig && periodConfig !== "") ||
        this.state.month !== month ||
        this.state.year !== year ||
        this.state.isPeriodProgrammed !== isPeriodProgrammed ||
        (this.state.selectionChanged !== selectionChanged &&
          selectionChanged) ||
        newsletterNumber !== this.state.newsletterNumberState ||
        newsletterFrequency !== this.state.newsletterFrequencyState)
    ) {
      this.setState({
        periodConfig: periodConfig,
        month: month,
        year: year,
        isPeriodProgrammed: isPeriodProgrammed,
        selectionChanged: selectionChanged,
        newsletterNumberState: newsletterNumber,
        newsletterFrequencyState: newsletterFrequency,
        newsletterChangedState: newsletterChanged,
      });

      // Le blog repasse son articleNewsletterId a null le temps de recharger
      // sa selection. Ce null transitoire ne doit pas effacer celui de la
      // campagne (une selection reellement videe renvoie l'id, pas null).
      if (articleNewsletterId) {
        setCurrentCampaign({ articleNewsletterId });
      }
    }

    const newsletterSelectionChanged =
      newsletterChanged &&
      (newsletterNumber !== this.props.newsletterNumber ||
        newsletterFrequency !== this.props.newsletterFrequency ||
        neweletterLanguage !== this.props.neweletterLanguage);

    if (event.data.continue || newsletterSelectionChanged) {
      this.setState({ suppressAutoPreview: false });
    }
     if (newsletterSelectionChanged) {
      setCurrentCampaign({ languageEdited: false });
      setSendType("scheduled");
      setCurrentCampaign({ scheduledDeliveryAt: null });
    }
    if (event.data.continue) {
      setCurrentCampaign({ currentSideBar: "PARAMS" });
    }
    setUaNewsletterNumber(newsletterNumber);
    setNewsletterChanged(newsletterChanged);
    setNewsletterFrequency(newsletterFrequency);
    setNewletterLanguage(neweletterLanguage);
  };

  resolveNewsletterChannel = (articles = []) => {
    return this.props.fetchNewsletterChannel(
      getFirstArticleChannelId(articles),
    );
  };

  fetchAllArticles = async () => {
    const { fetchNewsletterUAArticles, addFeedToNewsletter } = this.props;

    await fetchNewsletterUAArticles()
      .then(async (res) => {
        const allArticles = res.value.data.data?.articles?.slice(0, 8) || [];
        const allEvent = res.value.data.data.events?.slice(0, 2) || [];
        const allWakeUps = res.value.data.data.wakeups?.slice(0, 2) || [];
        const allTaxtvshow = res.value.data.data?.taxtvshow?.slice(0, 2) || [];

        await enrichAuthorsWithNewsletterImage(allArticles);
        await this.resolveNewsletterChannel(allArticles);

        allArticles.forEach((article) => {
          addFeedToNewsletter({
            ...formatArticle(article),
            type: "NEWS_LAYOUT",
          });
        });
        allWakeUps.forEach((wakeUp) => {
          addFeedToNewsletter({
            ...formatWakeUp(wakeUp),
            type: "WAKEUP_LAYOUT",
          });
        });
        allTaxtvshow.forEach((taxtvshow) => {
          addFeedToNewsletter({
            ...formatTaxtvshow(taxtvshow),
            type: "TAXTVSHOW_LAYOUT",
          });
        });
        allEvent.forEach((event) => {
          addFeedToNewsletter({
            ...formatFormation(event),
            type: "FORMATION_LAYOUT",
          });
        });
        this.setState({
          constructDesign: allArticles.length > 0,
          hasArticles: allArticles.length > 0,
        });
      })
      .catch((error) => {
        console.error("Error fetching articles:", error);
        this.setState({ hasArticles: false, constructDesign: false });
      });
  };

  fetchPersonalizedArticles = async (rawData) => {
    const {
      fetchNewsletterUAArticlesByPeriod,
      addFeedToNewsletter,
      auth,
      setCurrentCampaign,
    } = this.props;
    const { plan } = this.state;
    const requestId = ++this.latestPersonalizedArticlesRequestId;

    if (!auth?.currentClient?.id) return;

    const data = { ...rawData, plan };
    try {
      const res = await fetchNewsletterUAArticlesByPeriod(data);

      if (requestId !== this.latestPersonalizedArticlesRequestId) {
        return;
      }

      const payload = res?.value?.data?.data;
      if (!payload) throw new Error("Invalid response structure");

      if (payload.id) {
        setCurrentCampaign({ articleNewsletterId: payload.id });
      }

      const articles = payload.articles?.slice(0, 8) || [];
      const events = payload.events?.slice(0, 2) || [];
      const wakeups = payload.wakeups?.slice(0, 2) || [];
      const taxtvshow = payload.taxtvshow?.slice(0, 2) || [];

      await enrichAuthorsWithNewsletterImage(articles);
      await this.resolveNewsletterChannel(articles);

      articles.forEach((article) =>
        addFeedToNewsletter({ ...formatArticle(article), type: "NEWS_LAYOUT" }),
      );

      wakeups.forEach((wakeUp) =>
        addFeedToNewsletter({ ...formatWakeUp(wakeUp), type: "WAKEUP_LAYOUT" }),
      );

      taxtvshow.forEach((show) =>
        addFeedToNewsletter({
          ...formatTaxtvshow(show),
          type: "TAXTVSHOW_LAYOUT",
        }),
      );

      events.forEach((event) =>
        addFeedToNewsletter({
          ...formatFormation(event),
          type: "FORMATION_LAYOUT",
        }),
      );

      this.setState({
        constructDesign: articles.length > 0,
        hasArticles: articles.length > 0,
      });
    } catch (error) {
      if (requestId !== this.latestPersonalizedArticlesRequestId) {
        return;
      }

      console.error("Fetch failed:", error);

      const shouldRetry =
        auth.currentClient?.businessType !== "MASTER_CHAIN" &&
        auth.currentClient.id !== 9 &&
        !data.communityId;

      if (shouldRetry) {
        return this.fetchPersonalizedArticles({
          ...data,
          communityId: 9,
        });
      }

      this.setState({ constructDesign: false, hasArticles: false });
    }
  };

  handleGenerateHtml = (generateHtml) => {
    this.setState({ generateHtml });
  };

  handleSetNewsletter = (setNewsletter) => {
    this.setState({ setNewsletter });
  };

  handleCampaignListPageChange = ({ selected }) => {
    this.props.setEmailPaginationPage(selected + 1);
  };

  handleSetCurrentPage = (selected, id, extraData = {}) => {
    this.setState({
      newsletterId: id,
      currentPage: selected,
      ...extraData,
    });
    this.handleGenerateHtml(false);
    this.props.initNewsletterFeeds();
  };

  renderPaginate() {
    let { campaigns, paginationPage, pageSize } = this.props;
    if (campaigns.error != null && campaigns.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleCampaignListPageChange}
        pageSize={pageSize}
        nbResult={campaigns.nbResult}
        paginationPage={paginationPage}
      />
    );
  }

  toggleCreateNewsletterPage = () => {
    this.props.setCurrentCampaign({ articleNewsletterId: null });
    this.setState({ newsletterId: null, currentPage: "CHOICE_PAGE" });
  };

  handleShowPreview = () => {
    const {
      setCurrentDndTheme,
      currentTheme,
      setCurrentCampaignTheme,
      templates,
      html,
      themeCampaign,
    } = this.props;
    const { setNewsletter, currentPage } = this.state;

    const sidebar = document.getElementById("settings__sidebar");
    if (sidebar) {
      sidebar.classList.add("display");
      const mask = document.getElementsByClassName("mask").item(0);
      if (mask) {
        mask.classList.remove("hide");
      }
    }

    // Handle 'texte enrichi' apercu
    if (currentPage === "RICH_TEXT_PAGE") {
      if (html && html.length > 0) {
        let theme = {
          ...themeCampaign,
        };
        setCurrentDndTheme(theme);
        setCurrentCampaignTheme(theme);
        this.setState({ showPreview: true, selectionChanged: false });
      } else {
        // If no HTML content available, still show preview but it might be empty
        this.setState({ showPreview: true, selectionChanged: false });
      }
      return;
    }

    // Handle newsletter editor preview
    if (setNewsletter && currentTheme?.design) {
      if (currentTheme?.content) {
        const theme = {
          ...currentTheme,
          id: themeCampaign?.id,
          design: currentTheme.design,
          content: currentTheme.content,
        };

        setCurrentDndTheme(theme);
        setCurrentCampaignTheme(theme);
        this.setState({ showPreview: true, selectionChanged: false });
      } else {
        let editor = (this.editor && this.editor.editor) || window.unlayer;

        if (!editor || typeof editor.exportHtml !== "function") {
          return;
        }

        editor.exportHtml(({ html, design }) => {
          let theme;

          if (templates && templates.length > 0) {
            theme = {
              ...currentTheme,
              id: themeCampaign?.id,
              design,
              content: html,
            };
          } else {
            theme = {
              ...currentTheme,
              design,
              content: html,
            };
          }

          setCurrentDndTheme(theme);
          setCurrentCampaignTheme(theme);
          this.setState({ showPreview: true, selectionChanged: false });
        });
      }
    }
  };

  mapCampaignGroupIds(campaignGroups) {
    let oldCampaignGroups = this.props.currentCampaign.oldCampaignGroups;
    if (!oldCampaignGroups || !oldCampaignGroups.length) {
      return campaignGroups;
    }
    oldCampaignGroups.forEach((oldCampaignGroup) => {
      for (let i = 0; i < campaignGroups.length; i++) {
        if (
          campaignGroups[i].group === oldCampaignGroup.group.id &&
          campaignGroups[i].status === oldCampaignGroup.status
        ) {
          campaignGroups[i].id = oldCampaignGroup.id;
        }
      }
    });
    return campaignGroups;
  }

  getCampaignGroups() {
    let campaignGroups = [];
    let { allowedGroups, deniedGroups } = this.props.currentCampaign;
    if (!(allowedGroups instanceof Array)) {
      allowedGroups = allowedGroups.split(",");
    }
    if (!(deniedGroups instanceof Array)) {
      deniedGroups = deniedGroups.split(",");
    }
    if (allowedGroups.length > 0) {
      for (let i = 0; i < allowedGroups.length; i++) {
        if (allowedGroups[i]) {
          campaignGroups.push({ group: allowedGroups[i], status: "INCLUDE" });
        }
      }
    }
    if (deniedGroups.length > 0) {
      for (let i = 0; i < deniedGroups.length; i++) {
        if (deniedGroups[i]) {
          campaignGroups.push({ group: deniedGroups[i], status: "EXCLUDE" });
        }
      }
    }
    return this.mapCampaignGroupIds(campaignGroups);
  }

  canSaveData = () => {
    let { from, fromName, object, language, pageUrl, type, html } =
      this.props.currentCampaign;
    let hasValidContent =
      type === "WEB_PAGE"
        ? pageUrl && pageUrl.length > 0
        : html && html.length > 0;

    return (
      isValidEmail(from) &&
      hasValidLength(fromName, 3) &&
      hasValidLength(object, 5, 200) &&
      language &&
      hasValidContent
    );
  };

  updateThemeBeforeSave = () => {
    return new Promise((resolve) => {
      const {
        setCurrentDndTheme,
        currentTheme,
        setCurrentCampaignTheme,
        templates,
        html,
        themeCampaign,
      } = this.props;
      const { setNewsletter, currentPage } = this.state;

      // Cas RICH_TEXT_PAGE
      if (currentPage === "RICH_TEXT_PAGE") {
        if (html && html.length > 0) {
          const theme = { ...themeCampaign };
          setCurrentDndTheme(theme);
          setCurrentCampaignTheme(theme);
        }
        return resolve();
      }

      // Cas newsletter DND
      if (setNewsletter && currentTheme?.design) {
        if (currentTheme?.content) {
          const theme = {
            ...currentTheme,
            id: themeCampaign?.id,
            design: currentTheme.design,
            content: currentTheme.content,
          };
          setCurrentDndTheme(theme);
          setCurrentCampaignTheme(theme);
          return resolve();
        } else {
          const editor = (this.editor && this.editor.editor) || window.unlayer;

          if (!editor || typeof editor.exportHtml !== "function") {
            return resolve();
          }

          editor.exportHtml(({ html, design }) => {
            const theme =
              templates && templates.length > 0
                ? {
                    ...currentTheme,
                    id: themeCampaign?.id,
                    design,
                    content: html,
                  }
                : { ...currentTheme, design, content: html };

            setCurrentDndTheme(theme);
            setCurrentCampaignTheme(theme);
            return resolve();
          });
          return;
        }
      }

      resolve();
    });
  };

  handleSaveCampaign = (action = "DRAFT") => {
    let { allFiltersTab } = this.state;
    let { totalUniqueRecipients, manualRecipients, numCampaign } = this.props;

    if (!this.canSaveData()) {
      toast.info(_("Merci de vérifier l'aperçu avant d'envoyer la newsletter"));
      return;
    }

    const selectAllRecipientsTypes =
      allFiltersTab.length > 0 &&
      allFiltersTab.every((recipient) => recipient.selectAllRecipient === true);

    let type;
    if (this.state.currentPage === "SEND_PAGE") {
      type = "DND_TEMPLATE";
    } else if (this.state.currentPage === "RICH_TEXT_PAGE") {
      type = "PLAIN_TEXT";
    } else {
      type = "UNKNOWN_TYPE";
    }

    this.updateThemeBeforeSave().then(() => {
      let data = {
        campaignGroups: this.getCampaignGroups(),
        action,
        type,
        newsLetter: 1,
        isUAVersion: true,
        numCampaign: numCampaign,
        navigate: this.props.navigate,
        location: this.props.location,
      };

      if (selectAllRecipientsTypes) {
        data.nbUniqueRecipients = totalUniqueRecipients
          ? totalUniqueRecipients +
            (manualRecipients ? manualRecipients.length : 0)
          : 0;
      }

      let notification = { body: "campaignAdded", title: "addCampaignSuccess" };
      this.handleGenerateHtml(false);

      if (this.props.isUaNewsletter) {
        this.setState({ newsletterId: null });
        if (
          this.props.programmedDate != null &&
          moment(this.props.programmedDate).isValid()
        ) {
          this.props.setCurrentEmailCampaignData({
            id: null,
            scheduledDeliveryAt: this.props.programmedDate,
          });
        }
      }

      this.props.persistCampaign(data).then(
        (res) => {
          onSuccess(res, notification);
          this.props.fetchCampaigns();
          this.setState({
            newsletterId: null,
            generateHtml: false,
            currentPage: "LIST_PAGE",
          });
        },
        (err) => onError(err),
      );
    });
  };

  handleShowIframe = () => {
    let {
      language,
      auth,
      articleNewsletterId,
      currentTemplate,
      newsletterNumber,
      newsletterFrequency,
      isCampaignFetching,
    } = this.props;
    let { sendModeState, periodConfig } = this.state;

    // DrawerIframe freezes its url on mount. Building it while the campaign is
    // still loading would drop articleNewsletterId, and the blog would then
    // fall back to the current period and to its first newsletter instead of
    // the ones this campaign was built for.
    if (isCampaignFetching) {
      return <div style={{ height: "100vh" }} />;
    }

    let isNlSending = this.state.currentPage !== "PROGRAM_PAGE";
    const params = [];
    params.push("without_header=1");
    params.push("fiduciary=" + auth.currentClient.id);
    params.push("isNlSending=" + isNlSending);
    periodConfig && params.push("periodConfig=" + periodConfig);
    articleNewsletterId &&
      params.push("articleNewsletterId=" + articleNewsletterId);
    sendModeState && params.push("frequencyMode=" + sendModeState);
    newsletterNumber && params.push("newsletterNumber=" + newsletterNumber);
    newsletterFrequency &&
      params.push("newsletterFrequency=" + newsletterFrequency);
    return (
      <DrawerIframe
        key={sendModeState}
        src={`${TTP_BLOG_URL}${language}/programming-newsletters`}
        params={params}
        isBlog={true}
      />
    );
  };
  changeHasArticles = (value) => {
    this.setState({ hasArticles: value });
  };
  changeAllFiltersTab = (value) => {
    this.setState({ allFiltersTab: value });
  };
  handleDynamicFieldChange = (value) => {
    this.setState({ suppressAutoPreview: value ? value : false });
  };
  setEditorRef = (editor) => {
    this.editor = editor;
  };

  render() {
    let {
      campaigns,
      updating,
      isUaNewsletter,
      nbOfRecipients,
      inAdminSearchMode,
      currentStep,
    } = this.props;

    let {
      currentPage,
      constructDesign,
      showPreview,
      generateHtml,
      newsletterId,
      hasArticles,
      plan,
      isPeriodChanged,
      isPeriodProgrammed,
      periodConfig,
      senders,
      suppressAutoPreview,
    } = this.state;
    var isRecipientsNull = (nbOfRecipients || 0) < 1;
    return (
      <div className="newsletter-ua">
        <div
          className={`newsletter-ua-page ${
            [
              "MODELS_PAGE",
              "GENERIC_EMAILING",
              "GENERIC_EMAIL_FORM",
              "ADMINISTRATION",
              "USERS_PAGE",
              "SETTINGS_PAGE",
              "THEME_CATEGORIES",
            ].includes(currentPage)
              ? "newsletter-ua-page--models"
              : ""
          } ${currentPage === "LIST_PAGE" ? "newsletter-ua-page--list" : ""}`}
        >
          {currentPage !== "SEND_PAGE" && currentPage !== "RICH_TEXT_PAGE" && (
            <SubMenuUA
              currentPage={currentPage}
              handleSetCurrentPage={this.handleSetCurrentPage}
              plan={plan}
            />
          )}

          {currentPage === "PROGRAM_PAGE" && this.handleShowIframe()}
          {currentPage === "APPROVAL_PAGE" && (
            <ApprovalSettings isUAVersion={true} />
          )}
          {currentPage === "MODELS_PAGE" && (
            <ThemesListPage isUAVersion={true} />
          )}
          {currentPage === "GENERIC_EMAILING" && (
            <GenericEmailPage
              isUAVersion={true}
              handleSetCurrentPage={this.handleSetCurrentPage}
            />
          )}
          {currentPage === "GENERIC_EMAIL_FORM" && (
            <GenericEmail
              isUAVersion={true}
              settingId={this.state.genericSettingId}
              handleSetCurrentPage={this.handleSetCurrentPage}
            />
          )}
          {currentPage === "SETTINGS_PAGE" && (
            <DefaultSettings
              isUAVersion={true}
              handleSetCurrentPage={this.handleSetCurrentPage}
            />
          )}
          {currentPage === "ADMINISTRATION" && (
            <Administration
              isUAVersion={true}
              handleSetCurrentPage={() =>
                this.handleSetCurrentPage("LIST_PAGE", null)
              }
            />
          )}
          {currentPage === "USERS_PAGE" && (
            <Settings
              isUAVersion={true}
              handleSetCurrentPage={() =>
                this.handleSetCurrentPage("LIST_PAGE", null)
              }
            />
          )}

          {currentPage === "THEME_CATEGORIES" && (
            <ThemeCategoryList
              isUAVersion={true}
              handleSetCurrentPage={this.handleSetCurrentPage}
            />
          )}

          {(currentPage === "SEND_PAGE" ||
            currentPage === "RICH_TEXT_PAGE") && (
            <TopBar
              label="send an email"
              onClose={currentPage !== "LIST_PAGE" && this.handleSetCurrentPage}
              plan={plan}
            >
              {(currentPage === "SEND_PAGE" ||
                currentPage === "RICH_TEXT_PAGE") && (
                <div className="btn-container">
                  <button
                    className="btn success text-uppercase"
                    disabled={
                      (currentPage === "SEND_PAGE" && !hasArticles) ||
                      currentStep === "MODELS"
                    }
                    onClick={this.handleShowPreview}
                  >
                    {_("aperçu")}
                  </button>
                  <button
                    className="btn save text-uppercase"
                    onClick={() =>
                      !updating && this.handleSaveCampaign("DRAFT")
                    }
                    disabled={isRecipientsNull}
                  >
                    {updating && (
                      <img
                        src={"/img/icons/tail-spin.svg"}
                        className={"loading"}
                      />
                    )}
                    {updating
                      ? _("Processing")
                      : isUaNewsletter === "true"
                        ? _("aproveAndSave")
                        : _("save")}
                  </button>
                </div>
              )}
            </TopBar>
          )}

          {currentPage === "LIST_PAGE" && (
            <div className="newsletter-ua-page__list">
              <div className="newsletter-ua-page__sub-header">
                <div className="newsletter-ua-page__sub-header__info">
                  <div className="newsletter-ua-page__sub-header__info__title">
                    <img src={"/img/icons/inbox.svg"} />
                    <div className="title">
                      <h3>{_("list_campaigns")}</h3>
                      <p className="text-uppercase">
                        {_("list_campaigns_subtitle")}
                      </p>
                    </div>
                  </div>
                  <button
                    className="text-uppercase newsletter-ua-page__sub-header__btn"
                    onClick={this.toggleCreateNewsletterPage}
                    //disabled={!hasArticles}
                    title={!hasArticles ? _("warningEmptyNewsletter") : ""}
                  >
                    <img src={"/img/icons/addNl.svg"} />
                    {_("createCampaign")}
                  </button>
                </div>
              </div>
              <div className={"content-list"}>
                <CampaignListFilter />
                <hr className="h-separator" />
                {campaigns.fetching ? (
                  <div className="nb-campaigns gradient"></div>
                ) : (
                  <div className="row medium-11 nb-campaigns">
                    {ucFirst(_("number_of_campaigns"))} {" :"}&nbsp;
                    <span>{campaigns.nbResult}</span>
                  </div>
                )}
                {campaigns.error != null && campaigns.error.code === 404 ? (
                  <NotFound
                    principalText="Aucune campagne d'email n'a été crée"
                    text="Commencez par créer une nouvelle Newsletter "
                  />
                ) : (
                  <div
                    className={`row align-center medium-11 m-t-s`}
                    style={{ position: "relative", zIndex: "0" }}
                  >
                    <CampaignList
                      campaigns={campaigns}
                      isUAVersion={true}
                      handleSetCurrentPage={this.handleSetCurrentPage}
                      plan={plan}
                    />
                  </div>
                )}
                {!campaigns.fetching && (
                  <div className={`row align-center margin-bottom-2`}>
                    <div className={"column medium-11"}>
                      {this.renderPaginate()}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {currentPage === "SEND_PAGE" && (
            <NewsletterUASend
              constructDesign={constructDesign}
              handleGenerateHtml={this.handleGenerateHtml}
              generateHtml={generateHtml}
              handleSetNewsletter={this.handleSetNewsletter}
              newsletterId={newsletterId}
              plan={plan}
              handleShowIframe={this.handleShowIframe}
              isPeriodProgrammed={isPeriodProgrammed}
              periodConfig={periodConfig}
              month={this.state.month}
              year={this.state.year}
              fetchAllArticles={this.fetchAllArticles}
              fetchPersonalizedArticles={this.fetchPersonalizedArticles}
              changeHasArticles={this.changeHasArticles}
              changeAllFiltersTab={this.changeAllFiltersTab}
              handleSetCurrentPage={this.handleSetCurrentPage}
              senders={senders}
              initNewsletterFeeds={initNewsletterFeeds}
              initNewsletterBlocks={initNewsletterBlocks}
              setEditorRef={this.setEditorRef}
              setStateSendMode={(value) => {
                this.setState({ sendModeState: value });
              }}
              setPeriodConfig={(periodConfig) =>
                this.setState({ periodConfig })
              }
              handleDynamicFieldChange={this.handleDynamicFieldChange}
              suppressAutoPreview={suppressAutoPreview}
            />
          )}
          {currentPage === "STATS_PAGE" && (
            <StatisticsPage
              newsletterId={newsletterId}
              handleSetCurrentPage={this.handleSetCurrentPage}
            />
          )}
          {currentPage === "APPROVAL_RESPONSE" && (
            <ApprovalResponseWrapper
              handleSetCurrentPage={this.handleSetCurrentPage}
            />
          )}
          {currentPage === "CHOICE_PAGE" && (
            <ChoicePage
              currentPage={currentPage}
              handleSetCurrentPage={this.handleSetCurrentPage}
              plan={plan}
            />
          )}
          {currentPage === "RICH_TEXT_PAGE" && (
            <RichText
              constructDesign={constructDesign}
              handleGenerateHtml={this.handleGenerateHtml}
              generateHtml={generateHtml}
              handleSetNewsletter={this.handleSetNewsletter}
              newsletterId={newsletterId}
              plan={plan}
              handleShowIframe={this.handleShowIframe}
              isPeriodProgrammed={isPeriodProgrammed}
              periodConfig={periodConfig}
              handleSetCurrentPage={this.handleSetCurrentPage}
              currentPage={currentPage}
            />
          )}
          {currentPage === "EBOX_PAGE" && (
            <div>
              <PageHeader header="mailbox" subHeader="" icon="MAILBOX" />
              <div id="e-box-page">
                <List inOtherEbox={inAdminSearchMode} />
              </div>
            </div>
          )}
          {/*Hide e-box*/}
          {/* <MailExpressPage />*/}
        </div>
        <div className="mask hide" />
        {currentPage !== "LIST_PAGE" && (
          <PreviewSidebar
            showPreview={showPreview}
            newsletterId={newsletterId}
            isPeriodChanged={isPeriodChanged}
            currentPage={currentPage}
            suppressAutoPreview={suppressAutoPreview}
          />
        )}
      </div>
    );
  }
}

const NewsletterUAPageWithRouter = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <NewsletterUAPage {...props} navigate={navigate} location={location} />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewsletterUAPageWithRouter);
